import { useRef } from "react";
import {
    Flex,
    Link,
    Text,
    Group,
    IconButton,
    Button,
    HStack,
    VStack,
    Image,
    Drawer,
    useDisclosure,
    useBreakpointValue,
    Spacer,
    Separator,
    Portal,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { ColorModeSwitcherButton } from "./ColorMode";
import Logo from "../assets/logo.png";
import { LuMenu, LuX } from 'react-icons/lu';

export const LandingHeader = () => {
    const { open, onOpen, onClose } = useDisclosure();
    const isMobile = useBreakpointValue({ base: true, md: false });
    const textColor = "white";
    const btnRef = useRef();

    return (
        <VStack as="header" gap={0} bg="primary.900" color={textColor} width="100%">
            <Flex align="center" justify="space-between" p={4} color={textColor} width="100%">
                <Flex align="center">
                    <Link _hover={{ textDecoration: "none" }} asChild><RouterLink to="/">
                            <HStack>
                                <IconButton bg="white" _hover={{ bg: "grey" }}><Image src={Logo} alt="Logo" boxSize="2rem" /></IconButton>
                                <Text fontSize="lg" fontWeight="bold" color="white">
                                    LabChron
                                </Text>
                            </HStack>
                        </RouterLink></Link>
                </Flex>

                {isMobile ? (
                    <>
                        <IconButton
                            onClick={open ? onClose : onOpen}
                            variant="outline"
                            aria-label="Toggle Navigation"
                            color={"white"}>{open ? <LuX /> : <LuMenu />}</IconButton>
                        <Drawer.Root open={open} placement='end' finalFocusEl={() => btnRef.current} onOpenChange={e => {
                            if (!e.open) {
                                onClose();
                            }
                        }}>
                            <Portal>

                                <Drawer.Backdrop />
                                <Drawer.Positioner>
                                    <Drawer.Content>
                                        <Drawer.Header borderBottomWidth="1px">Navigation</Drawer.Header>
                                        <Drawer.Body>
                                            <VStack gap={4}>
                                                <Button variant="ghost" asChild><RouterLink to="/about" onClick={onClose}>About Us
                                                                                            </RouterLink></Button>
                                                {/*
                                                <Button as={RouterLink} to="/pricing" variant="ghost" onClick={onClose}>
                                                    Pricing
                                                </Button>
                                                */}
                                                <Button variant="ghost" asChild><RouterLink to="/milestones" onClick={onClose}>Milestones
                                                                                            </RouterLink></Button>
                                            </VStack>
                                        </Drawer.Body>
                                        <Drawer.Footer>
                                            <Group variant="ghost" gap={4}>
                                                <Button variant="solid" colorPalette="primary" asChild><Link href="https://www.labchron.app/login" onClick={onClose}>Go to Login
                                                                                            </Link></Button>
                                                <ColorModeSwitcherButton />
                                            </Group>
                                        </Drawer.Footer>
                                    </Drawer.Content>
                                </Drawer.Positioner>

                            </Portal>
                        </Drawer.Root>
                    </>
                ) : (
                    <HStack gap={4} width="50%">
                        <Spacer />
                        <Button variant='plain' color={textColor} asChild><RouterLink to="/about">About Us
                                                    </RouterLink></Button>
                        <Spacer />
                        {/*
                        <Button as={RouterLink} to="/pricing" variant="link" color={textColor}>
                            Pricing
                        </Button>
                        <Spacer />
                        */}
                        <Button variant='plain' color={textColor} asChild><RouterLink to="/milestones">Milestones
                                                    </RouterLink></Button>
                        <Spacer />
                    </HStack>
                )}

                {isMobile ? (
                    <> </>
                ) : (
                    <Group variant="ghost">
                        <Button variant="solid" colorPalette="primary" asChild><Link href="https://www.labchron.app/login" onClick={onClose}>Go to Login
                                                    </Link></Button>
                        <ColorModeSwitcherButton />
                    </Group>
                )}
            </Flex>
            <Separator bgColor="primary.500" borderColor="primary.500" variant="solid" height={1} maxWidth="full" mx="auto" />
        </VStack>
    );
};
